// SPDX-License-Identifier: GPL-3.0-or-later

export type PeerId = string;
export type RoomName = string;

export interface PeerInfo {
  id: PeerId;
  name: string;
  connected: boolean;
  audioLevel?: number;
  muted?: boolean;
}

export interface RoomSnapshot {
  name: RoomName;
  peers: Record<PeerId, PeerInfo>;
}

export interface IceServer {
  urls: string | string[];
  username?: string;
  credential?: string;
}

export interface TurnCredentialsResponse {
  username: string;
  password: string;
  ttl: number;
  iceServers: IceServer[];
}

export type ConnectionStatus =
  | 'initializing'
  | 'requesting-mic'
  | 'connecting'
  | 'connected'
  | 'error';

// Идентификатор room-координатора в сигналинге: пиры с таким ID владеют списком участников.
export const roomCoordinatorPeerId = (room: RoomName): string => `ffb-room-${room}`;

export const sanitizeRoomName = (raw: string): string =>
  raw
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '-');
